import Decimal from 'decimal.js';

import { convertMoneyToNumber } from './currency';

/**
 * Minimum booking total in EUR (major units), as shown to the guest.
 * Set manually in Sharetribe Console or when declining for "insufficient price".
 */
export const parseMinBookingPriceEur = publicData => {
  const raw = publicData?.minBookingPrice;
  const n = typeof raw === 'string' ? parseFloat(raw.trim()) : Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
};

/** Sum customer line-item totals (EUR major units), matching payin / "Precio total". */
export const estimatedCustomerPayinEur = lineItems => {
  if (!Array.isArray(lineItems) || lineItems.length === 0) {
    return null;
  }
  const customerLineItems = lineItems.filter(
    item => item?.includeFor && item.includeFor.includes('customer')
  );
  if (!customerLineItems.length) {
    return null;
  }
  return customerLineItems
    .reduce((sum, lineItem) => {
      const numericPrice = convertMoneyToNumber(lineItem.lineTotal);
      return sum.add(numericPrice);
    }, new Decimal(0))
    .toNumber();
};

export const isBookingBelowMinPrice = (minBookingPriceEur, lineItems) => {
  if (minBookingPriceEur == null) {
    return false;
  }
  const payinEur = estimatedCustomerPayinEur(lineItems);
  if (payinEur == null) {
    return false;
  }
  return payinEur < minBookingPriceEur;
};
